import Constants from 'expo-constants';

export const apiUrl = {
  dev: 'http://localhost:3001',
  staging: 'https://api.cpluspromo3.staging.zap.com.ph',
  preprod: 'https://api.cpluspromo3.preprod.zap.com.ph',
  prod: 'https://api.cpluspromo3.zap.com.ph',
};

const aboutUrl = {
  dev: 'https://www.canva.com/design/DAHXx9wRaYk/sakAIR_OVKG17DfNSSLQhg/view?embed',
  staging: 'https://www.canva.com/design/DAHXx9wRaYk/sakAIR_OVKG17DfNSSLQhg/view?embed',
  preprod: 'https://www.canva.com/design/DAHXx9wRaYk/sakAIR_OVKG17DfNSSLQhg/view?embed',
  prod: 'https://www.canva.com/design/DAHXx9wRaYk/sakAIR_OVKG17DfNSSLQhg/view?embed',
};

export const getApiUrl = (zenv = Constants.manifest.releaseChannel) => {
  if (__DEV__) return apiUrl.dev;
  if (zenv === 'staging') return apiUrl.staging;
  if (zenv === 'preprod') return apiUrl.preprod;
  if (zenv === 'prod') return apiUrl.prod;
};

export const getAboutUrl = (zenv = Constants.manifest.releaseChannel) => {
  if (__DEV__) return aboutUrl.dev;
  if (zenv === 'staging') return aboutUrl.staging;
  if (zenv === 'preprod') return aboutUrl.preprod;
  if (zenv === 'prod') return aboutUrl.prod;
};
